import React, { useState } from 'react';
import { StyledNuvoBox } from '#/common/styles/template';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import SimpleTextArea from '#/common/components/SimpleTextArea';
import InfoMessageWithSeeExample from '#/common/components/InfoMessageWithSeeExample';
import styled from 'styled-components';
import Modal from '#/common/components/Modal';
import exampleImage from '#/static/CapitalNeedsExampleTable.png';
import { InfoLabel } from '#/modules/admin/dataImport/components/styles';

const InfoMessageWrapper = styled.div`
  margin-bottom: 20px;
`;

const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const StyledInfoLabel = styled(InfoLabel)`
  margin-bottom: 20px;
`;

export interface PasteExcelDataStepProps {
  value: string;
  onChange: (value: string) => void;
}

const PasteExcelDataStep: React.FC<PasteExcelDataStepProps> = ({ value, onChange }) => {
  const { isDesktop } = useViewport();
  const [showExampleModal, setShowExampleModal] = useState(false);

  return (
    <>
      <StyledNuvoBox isDesktop={isDesktop}>
        <div className="box-caption">
          <NuvoLabel>Paste a Table</NuvoLabel>
        </div>
        <InfoMessageWrapper>
          <InfoMessageWithSeeExample
            message="You can copy a table of capital needs from an excel file. The table should follow a certain structure."
            showExample={() => {
              setShowExampleModal(true);
            }}
          />
        </InfoMessageWrapper>
        <NuvoLabel>Table</NuvoLabel>
        <SimpleTextArea
          name="paste-excel-data"
          value={value}
          onValueChanged={(e) => onChange(e.value)}
          placeholder="Paste your table here..."
          autoResizeEnabled={true}
          stylingMode="outlined"
        />
      </StyledNuvoBox>
      <Modal
        visible={showExampleModal}
        onHiding={() => setShowExampleModal(false)}
        title="Capital Needs Example Table"
        dragEnabled={true}
        content={
          <>
            <StyledInfoLabel>
              The table must include planning for at least 2 years.
              <br />
              Row containing the word "total" is treated as the "Sub-totals" row and will be
              automatically excluded during import.
            </StyledInfoLabel>
            <Img
              src={exampleImage}
              alt="Example of a capital needs table"
              onError={() => console.error('Failed to load example image')}
            />
          </>
        }
      />
    </>
  );
};

export default React.memo(PasteExcelDataStep);
